var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z",
    fill: "#FFB1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14461 5.29289C6.75408 4.90237 6.12092 4.90237 5.73039 5.29289C5.33987 5.68342 5.33987 6.31658 5.73039 6.70711L9.02329 10L5.73039 13.2929C5.33987 13.6834 5.33987 14.3166 5.73039 14.7071C6.12092 15.0976 6.75408 15.0976 7.14461 14.7071L10.4375 11.4142L13.7304 14.7071C14.1209 15.0976 14.7541 15.0976 15.1446 14.7071C15.5351 14.3166 15.5351 13.6834 15.1446 13.2929L11.8517 10L15.1446 6.70711C15.5351 6.31658 15.5351 5.68342 15.1446 5.29289C14.7541 4.90237 14.1209 4.90237 13.7304 5.29289L10.4375 8.58579L7.14461 5.29289Z",
    fill: "#F04D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRed);
export default __webpack_public_path__ + "static/media/IconRed.e943574b6f6301646b4e88f65ae7727b.svg";
export { ForwardRef as ReactComponent };